import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AuthGuard } from '../../shared/auth.guard';
import { ValuationReportPage } from './valuation-report/valuation-report.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.VALUATION_REPORT}`, pathMatch: 'full' },
            {
                path: `${Paths.VALUATION_REPORT}`,
                component: ValuationReportPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.VALUATION_REPORT,
                },
            },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class CompanyValuationModule {}
